import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "menu-tree" }
const _hoisted_2 = ["title"]
const _hoisted_3 = { class: "label-item" }
const _hoisted_4 = ["href"]
const _hoisted_5 = ["title"]

import MenuTree from "@/components/com/MenuTree"
	interface Props {
		menuData ?: object,
	}
	
export default /*@__PURE__*/_defineComponent({
  __name: 'MenuTree',
  props: {
    menuData: { default: [] }
  },
  setup(__props: any) {

	const props = __props

return (_ctx: any,_cache: any) => {
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuData, ({ id, path, children, icon, name }) => {
      return (_openBlock(), _createElementBlock("label", { key: id }, [
        children
          ? (_openBlock(), _createBlock(_component_el_sub_menu, {
              key: 0,
              index: path,
              "popper-class": "asdf"
            }, {
              title: _withCtx(() => [
                _createElementVNode("i", {
                  class: _normalizeClass(["ft-icon iconfont", icon]),
                  "aria-hidden": "true"
                }, null, 2),
                _createElementVNode("span", {
                  class: "textspan",
                  title: name
                }, _toDisplayString(name), 9, _hoisted_2)
              ]),
              default: _withCtx(() => [
                _createElementVNode("label", _hoisted_3, [
                  _createVNode(_unref(MenuTree), { menuData: children }, null, 8, ["menuData"])
                ])
              ]),
              _: 2
            }, 1032, ["index"]))
          : (_openBlock(), _createElementBlock("a", {
              key: 1,
              href: `/#${path}`
            }, [
              _createVNode(_component_el_menu_item, { index: path }, {
                default: _withCtx(() => [
                  icon
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 0,
                        class: _normalizeClass(["ft-icon iconfont", icon]),
                        "aria-hidden": "true"
                      }, null, 2))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", {
                    class: "textspan",
                    title: name,
                    slot: "title"
                  }, _toDisplayString(name), 9, _hoisted_5)
                ]),
                _: 2
              }, 1032, ["index"])
            ], 8, _hoisted_4))
      ]))
    }), 128))
  ]))
}
}

})